import { DrawingAppliance } from '@common/models/drawing-appliance.model';
import { CornerMap, DrawingEdge, RemovedElementsHistory } from '@common/models/drawing-shape.model';
import { EdgeModel } from '@common/models/edge.model';
import { Skeleton } from '@common/models/skeleton.model';

/**
 * Interface for what should be a explicitly serializable DrawingShape
 * CornerMap, DrawingEdge, and RemovedEdlementHistory must be made serializable as well
 */

export interface ISerializableDrawingShape {
    appliances: DrawingAppliance[];
    cornerMap: CornerMap;
    counterLabel?: number;
    drawingEdges: DrawingEdge[];
    edge?: EdgeModel;
    label?: string;
    removedElementsHistory?: RemovedElementsHistory; // every edge that's not finished edge
    skeleton: Skeleton;
    establishedLetterStartIndex?: number;
}

export class SerializableDrawingShape implements ISerializableDrawingShape {
    appliances: DrawingAppliance[];
    cornerMap: CornerMap;
    counterLabel?: number;
    drawingEdges: DrawingEdge[];
    edge?: EdgeModel;
    label?: string;
    removedElementsHistory?: RemovedElementsHistory;
    skeleton: Skeleton;
    establishedLetterStartIndex?: number;

    constructor(props: ISerializableDrawingShape) {
        this.appliances = props.appliances ?? undefined;
        this.cornerMap = props.cornerMap ?? {};
        this.counterLabel = props.counterLabel ?? undefined;
        this.drawingEdges = props.drawingEdges ?? [];
        this.edge = props.edge ?? undefined;
        this.label = props.label ?? undefined;
        this.removedElementsHistory = props.removedElementsHistory ?? undefined;
        this.skeleton = props.skeleton ?? [];
        this.establishedLetterStartIndex = props.establishedLetterStartIndex;
    }
}
